/* ===================================================================
   Lambda Coffee — Customily Varianten-Prefill (PDP)  ·  SCHRITT 1
   -------------------------------------------------------------------
   Hängt die aktuell gewählte Shopify-Variante zusätzlich als Customily-
   URL-Parameter an die Adresse an — Format:  ?@<Variable>=<Wert>
   OHNE den bestehenden ?variant=<id> zu verändern.

   Beispiel:
     vorher : /products/thermobecher-edelstahl?variant=50118693683466
     nachher: /products/thermobecher-edelstahl?variant=50118693683466&@Farbe=Brave%20Red

   Reagiert automatisch auf jeden Variantenwechsel (Dawn setzt die URL
   per history.replaceState -> wir hängen danach die @-Parameter an).
   Läuft nur auf personalisierbaren Produkten (Erkennung: der von der
   Customily-App injizierte Button #customily-personalize-button).
   =================================================================== */
(function () {
  'use strict';

  /* ====== KONFIGURATION =====================================================
     Zuordnung:  Shopify-Options-Name  ->  Customily-Variablenname (ohne @).
     Der Customily-Variablenname ist das Feld "Variable name" der jeweiligen
     Option im Customily-Editor.
       • Farbe -> "Farbe"   (bestätigt per Editor-Screenshot)
       • Größe -> "Größe"   (angenommen — bei Bedarf hier anpassen)
     Der Schlüssel muss EXAKT dem Shopify-Options-Namen entsprechen
     (inkl. Groß-/Kleinschreibung und Umlaut).
  ========================================================================== */
  var OPTION_MAP = {
    'Farbe': 'Farbe',
    'Größe': 'Größe'
  };

  // Optionen mit nur EINEM Wert (keine echte Auswahl, z.B. fixe Größe)
  // werden ausgelassen. Auf false setzen, um sie trotzdem anzuhängen.
  var SKIP_SINGLE_VALUE = true;
  // ==========================================================================

  // Native replaceState sichern (für das Setzen der URL ohne Rekursion).
  var origReplaceState = history.replaceState;

  // Aktuelle Varianten-Optionen als [{ name, value, valueCount }] auslesen.
  function getSelectedOptions() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return [];

    var variant = null;
    var node = vs.querySelector('[data-selected-variant]');
    if (node) { try { variant = JSON.parse(node.textContent); } catch (e) { /* ignore */ } }
    var values = (variant && Array.isArray(variant.options)) ? variant.options : [];

    var out = [];
    vs.querySelectorAll('fieldset').forEach(function (fs, i) {
      var legend = fs.querySelector('legend');
      // Legend-Text ist "Optionsname: Wert" -> Name = Teil vor dem ersten ":"
      var name = legend ? legend.textContent.split(':')[0].replace(/\s+/g, ' ').trim() : '';

      var select = fs.querySelector('select');
      var valueCount = select ? select.options.length
                              : fs.querySelectorAll('input[type="radio"]').length;

      // Wert bevorzugt positionsgenau aus der Varianten-JSON, sonst aus dem Control.
      var value = values[i];
      if (value == null) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        value = checked ? checked.value : (select ? select.value : null);
      }

      if (name && value != null) out.push({ name: name, value: value, valueCount: valueCount });
    });
    return out;
  }

  // Baut die @-Parameter (z.B. ["@Farbe=Brave%20Red"]) aus den gewählten Optionen.
  function buildCustomilyParams() {
    return getSelectedOptions()
      .filter(function (o) {
        if (!Object.prototype.hasOwnProperty.call(OPTION_MAP, o.name)) return false;
        if (SKIP_SINGLE_VALUE && o.valueCount <= 1) return false;
        return o.value !== '' && o.value != null;
      })
      .map(function (o) {
        // "@" und "=" bleiben literal, nur der Wert wird encodiert (Leerzeichen -> %20).
        return '@' + OPTION_MAP[o.name] + '=' + encodeURIComponent(o.value);
      });
  }

  // URL neu setzen: bestehende Parameter (inkl. ?variant=) behalten,
  // alte @-Parameter entfernen, aktuelle @-Parameter anhängen.
  function syncUrl() {
    var loc = window.location;
    var atParams = buildCustomilyParams();

    var kept = loc.search.replace(/^\?/, '').split('&').filter(Boolean).filter(function (pair) {
      var key = pair.split('=')[0];
      try { key = decodeURIComponent(key); } catch (e) { /* ignore */ }
      return key.charAt(0) !== '@'; // alte @-Parameter verwerfen
    });

    var all = kept.concat(atParams);
    var newSearch = all.length ? '?' + all.join('&') : '';
    var newUrl = loc.pathname + newSearch + loc.hash;

    if (newUrl !== loc.pathname + loc.search + loc.hash) {
      origReplaceState.call(history, history.state, '', newUrl);
    }
  }

  // history.replaceState/pushState umschließen: Dawn setzt bei jedem
  // Variantenwechsel die URL auf ?variant=<id> — danach hängen wir an.
  var installed = false;
  function install() {
    if (installed) return;
    installed = true;

    var guard = false;
    function wrap(orig) {
      return function () {
        var ret = orig.apply(history, arguments);
        if (!guard) {
          guard = true;
          try { syncUrl(); } finally { guard = false; }
        }
        return ret;
      };
    }
    history.replaceState = wrap(history.replaceState);
    history.pushState = wrap(history.pushState);

    syncUrl(); // Initialer Lauf (z.B. Aufruf über einen ?variant=-Link).
  }

  // Nur auf personalisierbaren Produkten aktiv werden: der Customily-Button
  // wird von der App asynchron injiziert -> kurz darauf warten.
  function isPersonalizable() {
    return !!document.querySelector('#customily-personalize-button');
  }
  function boot(attempts) {
    if (isPersonalizable()) { install(); return; }
    if (attempts <= 0) return;
    setTimeout(function () { boot(attempts - 1); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(20); });
  } else {
    boot(20);
  }
})();
